import { createContext, useContext } from 'react';

export interface AiOverlayContextValue {
    aiOverlayOn: boolean;
    aiOverlayLoading: boolean;
    showAiOverlayToggle: boolean;
    toggleAiOverlay: () => void;
    hasAiOverlayEverBeenOn: boolean;
}

// AI overlay is only wired up (via AiOverlayProvider) on the VideoEventDetails page. The shared
// VideoViews/Layouts components that read this context are also reused elsewhere (e.g. the VideoRecall
// preview step) with no such provider, so the default must be a safe no-op rather than throwing.
const defaultAiOverlayContextValue: AiOverlayContextValue = {
    aiOverlayOn: false,
    aiOverlayLoading: false,
    showAiOverlayToggle: false,
    toggleAiOverlay: () => {},
    hasAiOverlayEverBeenOn: false,
};

const AiOverlayContext = createContext<AiOverlayContextValue>(defaultAiOverlayContextValue);

const useAiOverlayContext = (): AiOverlayContextValue => useContext(AiOverlayContext);

export { AiOverlayContext, useAiOverlayContext };
